<template>
	<div class="container map">
		<l-map
				id="osm-map"
				:zoom="zoom"
				:center="center"
				:options="mapOptions"
				ref="map"
		>
			<l-tile-layer
					:url="url"
					:attribution="attribution"
			/>
		</l-map>
		<!-- start Navigation -->
		<div class="panel_center-top">
			<div class="map-button"
					 v-on:click="toggleAllCars()"
					 v-bind:class="{ 'map-button__active' : status.allCars }">
				<img src="../assets/img/map/show_car_off.svg" v-if="!status.allCars">
				<img src="../assets/img/map/show_car_on.svg" v-if="status.allCars">
			</div>
			<div class="map-button"
					 v-on:click="toggleLastPath()"
					 v-bind:class="{ 'map-button__active' : status.activeLast }">
				<img src="../assets/img/map/car_track_on.svg" v-if="status.activeLast">
				<img src="../assets/img/map/car_track_off.svg" v-else>
			</div>
		</div>
		<div class="panel_right-top">
			<div class="map-button" @click="toogleMapChoise">
				<img src="../assets/img/map/map_select.svg">
			</div>
			<div class="choise-map" v-if="showMapChoise">
				<div class="choise-map_item"
						 :class="{ 'active' : typeMap === 0 }"
						 @click="changeMapType(0)">
					<img src="../assets/img/map/osm-icon.png"/>
					<div>
						OSM
					</div>
				</div>
				<div class="choise-map_item"
						 :class="{ 'active' : typeMap === 1 }"
						 @click="changeMapType(1)">
					<img src="../assets/img/map/gmap-icon.png"/>
					<div>
						Google
					</div>
				</div>
			</div>
		</div>
		<div class="panel_right-center">
			<div class="map-button map-button"
					 v-bind:class="{ 'map-button__active' : status.focus }"
					 v-on:click="toggleFocus()">
				<img src="../assets/img/map/focus_car.svg" v-if="status.focus">
				<img src="../assets/img/map/focus_off.svg" v-else>
				<!--
				<img src="../assets/img/map/focus_user.svg">
				<img src="../assets/img/map/focus_car&user.svg">-->
			</div>
			<div class="map-button map-button_zoom-in"
					 v-on:click="zoomIn()">
				<img src="../assets/img/map/zoom_in.svg"/>
			</div>
			<div class="map-button map-button_zoom-out"
					 v-on:click="zoomOut()">
				<img src="../assets/img/map/zoom_out.svg"/>
			</div>
		</div>
	</div>
</template>

<script>
  import { latLng, icon } from "leaflet";
  import { LMap, LTileLayer } from 'vue2-leaflet';
  import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
  import 'leaflet/dist/leaflet.css';
  import { HTTP } from '../main'

  export default {
    name: "OSM",
		data : () => {
      return{
      	zoom: 13,
        center: latLng(55.6507838, 37.441247),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        currentZoom: 11.5,
        currentCenter: latLng(55.6507838, 37.441247),
        showParagraph: false,
        mapOptions: {
					zoomSnap: 0.5,
          zoomControl: false
				},
				iconMarker : icon({
          iconUrl: require('../assets/img/map/stop-main.png'),
					rotationAngle: 45
        }),

        // Точки маршрута
        way : {
          current : [],
          route   : [],
          last    : [],
          car     : [],
        },

        // Объекты карты
        markers : [
        ],
        markersAll : [
        ],
        markerList : [],

        plateAll : [],

        polylines : {
          main  :  '',
          bg    :  '',
          gap   :  '',
          day   :  {
            bg   : [],
            main : []
          }
        },
        icon : {
        },

        speedWay : {
          id : '',
          speeds : [],
          mapObjects : [],
          colors : {
            low : '#fd4741',
            medium : '#ffd000',
            high : '#009c52',
            veryhigh : '#0077c6',
            rampage : '#003366'
          },
          markers : [],
          infoWindow : '',
          lastInfoIndex : -1
        },

        networkTower : {
          Circles : [],
          Way : []
        },

        // Состояние
        status : {
          focus      : true,
          activeLast : true,
          allCars 	 : false,
        },

        // Пробки
        traffic : {
          layer   : '',
          status  : false,
          load    : 0
        },


        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

      }
		},
    mounted(){
      this.unsubscribeAction = this.$store.subscribeAction({
        after: (action) => {
          if( action.type === 'changeHistoryDay' ){ // Выбор всех поездок за день
            this.changeHistoryDay();
          }
          if( action.type === 'journalRouteItem' ){ // Поменялся тип/активный элемент в журнале
            if( this.panelCar === 2 ){
              this.setJournal();
            }
          }
          if( action.type === 'journalEventItem' ){ // Поменялся тип/активный элемент в евентах
            if( this.panelCar === 2 ){
              this.setJournal();
            }
          }
        }
      });
      setTimeout( () => {
        if( this.currentId !== '' ){
          if( this.panelCar === 1 ){
            this.setManagment();
          }else if( this.panelCar === 2 ){
            if( this.historyDay === 'empty' ){
              this.setJournal();
            }else{
              this.setJournalDay( this.historyDay );
            }
          }
        }
      }, 300);
    },
    beforeDestroy() {
      this.unsubscribeAction();
    },
    computed : {
      currentId : function () {
        return this.$store.state.cars.current.id
      },
      lastState : function () {
        return this.$store.state.cars.lastSocket.state
      },
      lastRoute : function () {
        return this.$store.state.cars.lastSocket.route
      },
      stateCar : function(){
        return this.$store.state.cars.state[this.currentId]
      },
      routeCar : function(){
        return this.$store.state.cars.route[this.currentId]
      },
      journalStore : function () {
        return this.$store.state.journal
      },
      panelCar : function () {
        return this.$store.state.panels.car
      },
      plateList : function(){
        let plateList = {};

        for( let i = 0; i < this.$store.state.cars.list.length; i++ ){
          plateList[this.$store.state.cars.list[i].id] = this.$store.state.cars.list[i].registration_id;
        }

        return plateList;
      },
      historyDay: function () {
        return this.$store.state.map.historyDay
      },
			typeMap : function () {
				return this.$store.state.map.type
      },
			showMapChoise : function () {
        return this.$store.state.map.showChoise
      },
    },
		methods : {
      changeCar : function () {
        this.way.car     = [];
        this.way.current = [];
        this.way.route   = [];

        this.showAllCars();
        this.setManagment();
			},
      setManagment : function () {
        if( this.stateCar.is_in_route === true ){ // Если едем
          this.changeState();
          this.changeRoute();
        }else{                                    // Если стоим
          this.getLastWay();
          this.setCar();
        }
      },

      // Отслеживаем изменение выбранного дня
      changeHistoryDay : function() {
        if( this.historyDay === 'empty' ){
          this.setJournal();
        }else{
          this.setJournalDay( this.historyDay );
        }
      },
      // Установки для Журнала
      setJournal : function (){
        const L = window.L;
        const map = this.$refs.map.mapObject;

        this.clearMarkers();
        this.clearPolylines();

        if( this.journalStore.type === 0 ){ // Маршрут
          if( this.journalStore.menuItem.type === 0 ){ // Поездка

            HTTP.get('cars/' + this.currentId + '/routes/' + this.journalStore.menuItem.id + '/')
              .then( (response) => {
                if( response.data.speed[0] === null ){
                  if( response.data.coord_src === 2 || response.data.coord_src === 0 ){
                    this.drawPointNetworkTower();
                  }else{
                    this.drawSingleWay();
                  }
                }else{
                  this.speedWay.speeds = response.data.speed;
                  this.drawSpeedWay();
                }
              })
              .catch( () => {
                this.drawSingleWay();
                //this.$store.dispatch('errorResponse', error );
              })
            ;

          }else{ // Стоянка
            // Маркер стоянки
            let marker = new L.marker(
              [
                this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
                this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
							],
              {
                icon : L.icon({
                  iconUrl: require('../assets/img/map/stop-main.png'),
                  iconSize: [28, 32],
                }),
                draggable : false
              }
            );
            this.markers.push( marker );
            map.addLayer(marker);

            // Центрируем карту
            map.panTo( new L.LatLng(
              this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
              this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
						));
          }
        }else{ // Событие

          let icon;
          if(  this.journalStore.menuItem.id !== 205
            && this.journalStore.menuItem.id !== 226
            && this.journalStore.menuItem.id !== 218
            && this.journalStore.menuItem.id !== 219
            && this.journalStore.menuItem.id !== 200
            && this.journalStore.menuItem.id !== 271
            && this.journalStore.menuItem.id !== 267
            && this.journalStore.menuItem.id !== 222
            && this.journalStore.menuItem.id !== 213
            && this.journalStore.menuItem.id !== 215
            && this.journalStore.menuItem.id !== 216
            && this.journalStore.menuItem.id !== 214 ){
            icon = require('../assets/img/map/points/m' + this.journalStore.menuItem.id + '.svg')
          }else{
            icon = require('../assets/img/map/point.png')
          }


          let marker = new L.marker(
            [this.journalStore.menuItem.point[0], this.journalStore.menuItem.point[1]],
            {
              icon : L.icon({
                iconUrl: icon,
                iconSize: [40, 43],
              }),
              draggable : false
            }
          );
          this.markers.push( marker );
          map.addLayer(marker);


          map.panTo( new L.LatLng(
            this.journalStore.menuItem.point[0],
            this.journalStore.menuItem.point[1]
          ));
        }
      },
      // Полный день
      setJournalDay : function ( listPoints ) {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        this.clearMarkers();
        this.clearPolylines();

        let points = [];
        //
        for( let i = 0; i < listPoints.length; i++ ){
          if( listPoints[i].type === 1 ){
            if( i !== 0 && i !== listPoints.length-1 ){
              // Маркер промежуточный
              let marker = new L.marker(
                [listPoints[i].listPoints[0].lat, listPoints[i].listPoints[0].lng],
                {
                  icon : L.icon({
                    iconUrl: require('../assets/img/map/stop-small.png'),
                    iconSize: [10, 10],
                  }),
                  draggable : false,
                  zIndexOffset: 99,
                }
              );
              this.markers.push( marker );
              map.addLayer(marker);
            }
          }else{
            // Рисуем подложку маршрута
						let line = L.polyline(
              listPoints[i].listPoints,
              { color: '#000',
                weight : 6.6  }
            );
            this.polylines.day.bg.push( line );

            // Рисуем маршрут
            line = L.polyline(
              listPoints[i].listPoints,
              { color: '#1aad03',
                weight : 6  }
            );
            this.polylines.day.main.push( line );

            let j = this.polylines.day.main.length-1;

            this.polylines.day.bg[j].addTo(map);
            this.polylines.day.main[j].addTo(map);
          }

          let b = listPoints[i].listPoints.map( item => {
            return [ item.lat, item.lng ]
          });
          points = points.concat( b );
        }

        // Маркер куда ехали
        let marker = new L.marker(
          [
            listPoints[0].listPoints[listPoints[0].listPoints.length-1].lat,
            listPoints[0].listPoints[listPoints[0].listPoints.length-1].lng
					],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointB.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);


        // Маркер откуда ехали
        marker = new L.marker(
          [
            listPoints[listPoints.length-1].listPoints[0].lat,
            listPoints[listPoints.length-1].listPoints[0].lng
          ],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointA.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        // Вписываем область
        map.fitBounds( points );
      },

      // Отрисовка пути со скоростями
      drawSpeedWay : function(){
        const L = window.L;
        const map = this.$refs.map.mapObject;

        let points = this.journalStore.menuItem.listPoints.map( item => {
					return [ item.lat, item.lng ]
				});
        let speeds = this.speedWay.speeds;
        let way = [{ points : [], speeds : [], type : '' }];

        // Рисуем подложку маршрута
        this.polylines.bg = L.polyline(
          points,
          { color: '#000',
            weight : 6.6  }
        );
        this.polylines.bg.addTo(map);

        if( this.speedWay.infoWindow !== '' ){
          map.removeLayer( this.speedWay.infoWindow );
          this.speedWay.infoWindow = '';
        }

        function speedType( val ){
          if ( val > 10 && val <= 25) {
            return 'medium';
          } else if ( val > 25 && val <= 90) {
            return 'high';
          } else if ( val > 90 && val <= 130) {
            return 'veryhigh';
          } else if ( val > 130 ){
            return 'rampage';
          }else{
            return 'low';
          }
        }

        way[0].points.push( points[0] );
        way[0].speeds.push( speeds[0] );
        way[0].type = speedType( speeds[0] );

        for( let i = 1; i < points.length; i++ ){
          let wL = way.length - 1;

          way[wL].points.push( points[i] );
          way[wL].speeds.push( speeds[i] );


          if( (speedType( speeds[i] ) !== way[wL].type) || i === points.length-1 ){

            // Рисуем маршрут
            let polCur = L.polyline(
              way[wL].points,
              {
                color: this.speedWay.colors[way[wL].type],
                weight : 6
              }
            );
            this.speedWay.mapObjects.push( polCur );
            polCur.addTo(map);

            // Показывание скорости на этой точке
            let p = way[way.length - 1].points;
            let s = way[way.length - 1].speeds;

            polCur.on( 'mouseover', () => {

              let pointsUnique = p.filter((e, i, a) =>
                i === a.findIndex( (j) => (
                  j[0] === e[0] && j[1] === e[1]
                ))
              );

              for (let j = 0; j < pointsUnique.length; j++ ) {
                let marker = new L.marker(
									pointsUnique[j],
                  {
                    icon : L.icon({
                      iconUrl: require('../assets/img/map/marker-speed.png'),
                      iconSize: [8, 8],
                    }),
                    opacity : 0.6,
                    bubblingMouseEvents : true,
                    draggable : false
                  }
                );
                this.speedWay.markers.push( marker );
                map.addLayer(marker);
              }
            });
            polCur.on('mouseout', () => {
              for (let i = 0; i < this.speedWay.markers.length; i++ ) {
                map.removeLayer(this.speedWay.markers[i]);
              }
              this.speedWay.markers = [];
            });

            polCur.on('click', (e) => {

              let a = p.map((x, index) => {
                return {
                  lat: e.latlng.lat - x[0],
                  lng: e.latlng.lng - x[1],
                  index: index
                }
              });
              let b = a.sort((x, y) => {
                let xC = Math.sqrt(Math.abs(x.lat) * Math.abs(x.lat) + Math.abs(x.lng) * Math.abs(x.lng));
                let yC = Math.sqrt(Math.abs(y.lat) * Math.abs(y.lat) + Math.abs(y.lng) * Math.abs(y.lng));

                return xC - yC;
              })[0];
              let closestIndex = b.index;

              if( this.speedWay.infoWindow !== '' ){
                map.removeLayer( this.speedWay.infoWindow );
                this.speedWay.infoWindow = '';
							}

              let marker = new L.marker(
                [ p[closestIndex][0], p[closestIndex][1] ],
                {
									icon : new L.DivIcon({
										className: 'info-window-marker',
										html: '<span> Скорость:<b>' + s[closestIndex] + 'км/ч</b></span>',
										iconAnchor : [48, 0],
									}),
                  draggable : false
                }
              );
              this.speedWay.infoWindow = marker;
              map.addLayer(marker);

              marker.on('click', () => {
                map.removeLayer( this.speedWay.infoWindow );
                this.speedWay.infoWindow = '';
              });
            });


            way.push({ points : [], speeds : [], type : speedType( speeds[i] ) });
            wL = way.length - 1;

            way[wL].points.push( points[i] );
            way[wL].speeds.push( speeds[i] );
          }
        }

        // Маркер откуда ехали
        let marker = new L.marker(
          [this.journalStore.menuItem.listPoints[0].lat, this.journalStore.menuItem.listPoints[0].lng],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointA.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        // Маркер куда ехали
        marker = new L.marker(
          [
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng,
          ],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointB.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        // Вписываем область
        map.fitBounds(this.polylines.bg.getBounds());
      },
      // Отрисовка пути без скоростей
      drawSingleWay : function(){
        const L = window.L;
        const map = this.$refs.map.mapObject;

        // Рисуем подложку маршрута
        this.polylines.bg = L.polyline(
          this.journalStore.menuItem.listPoints,
          { color: '#000000',
            weight : 6.6 }
        );
        this.polylines.bg.addTo(map);

        // Рисуем маршрут
        this.polylines.main = L.polyline(
          this.journalStore.menuItem.listPoints,
          { color: '#1aad03',
            weight : 6  }
        );
        this.polylines.main.addTo(map);


        // Маркер откуда ехали
        marker = new L.marker(
          [
            this.journalStore.menuItem.listPoints[0].lat,
            this.journalStore.menuItem.listPoints[0].lng
          ],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointA.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        let marker = new L.marker(
          [
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
          ],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointB.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        // Вписываем область
        map.fitBounds(this.polylines.bg.getBounds());
      },
      // Отрисовка точек по вышкам
      drawPointNetworkTower : function(){
        const L = window.L;
        const map = this.$refs.map.mapObject;

        let b = this.journalStore.menuItem.listPoints;
        let pointsUnique = b.filter((e, i, a) =>
          i === a.findIndex( (j) => (
            j.lat === e.lat && j.lng === e.lng
          ))
        );

        for (let i = 0; i < pointsUnique.length; i++ ) {
          let circle = new L.circle(
            pointsUnique[i],
						400,
						{color: '#12d4f0', opacity:.5});
          this.networkTower.Circles.push(circle);
          circle.addTo(map);
        }

        this.polylines.main = L.polyline(
          pointsUnique,
          { color: '#12d4f0',
            lineCap : 'round',
            dashArray: '3, 6',
            weight : 3  }
        );
        this.polylines.main.addTo(map);


        // Маркер откуда ехали
        let marker = new L.marker(
          [this.journalStore.menuItem.listPoints[0].lat, this.journalStore.menuItem.listPoints[0].lng],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointA.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);

        // Маркер куда ехали
        marker = new L.marker(
          [
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
            this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng,
          ],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/pointB.png'),
              iconSize: [40, 41],
              iconAnchor : [20, 38]
            }),
            draggable : false
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);


        map.fitBounds( pointsUnique );
      },


      // Изменился state
      changeState : function () {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        if( this.stateCar.is_in_route === true ){ // Если едем
          // собираем положения по state
          this.way.car.push({ lat: this.stateCar.lat, lng: this.stateCar.lng });

          // Очищаем маркеры
          this.clearMarkers();
          // Рисуем новый маркер
          let marker = new L.marker(
            [this.stateCar.lat, this.stateCar.lng],
            {
              icon : L.icon({
                iconUrl: require('../assets/img/map/car.svg'),
                iconSize: [45, 45],
                className : 'rotateCarIcon'
              }),
              rotationAngle : this.stateCar.course,
              rotationOrigin : 'center',
              draggable : false,
              zIndexOffset: 99,
            }
          );
          this.markers.push( marker );
          map.addLayer(marker);


          // Очищаем маршруты
          this.clearPolylines();
          // Рисуем и зазор маршрут
          if( this.status.activeLast ){
            // последний маршрут
            this.way.current = this.routeCar.tail;

            // Рисуем зазор
            this.polylines.gap = L.polyline(
              this.way.car,
              { color: '#676767',
                weight : 6.6  }
            );
            this.polylines.gap.addTo(map);

            // Рисуем подложку маршрута
            this.polylines.bg = L.polyline(
              this.way.current,
              { color: '#000',
                weight : 6.6  }
            );
            this.polylines.bg.addTo(map);
            // Рисуем маршрут
            this.polylines.main = L.polyline(
              this.way.current,
              { color: '#1aad03',
                weight : 6  }
            );
            this.polylines.main.addTo(map);
          }

          // Центрируем карту
          if( this.status.focus === true ){
            map.panTo(new L.LatLng(this.stateCar.lat, this.stateCar.lng));
          }
        }else{  // Если стоим
          this.getLastWay();
          this.setCar();
        }
      },
      // Изменился route
      changeRoute : function () {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        if( this.status.activeLast ){
          // последний маршрут
          this.way.current = this.routeCar.tail;
          // Стираем последние точки зазора
          this.way.car = [];
          // Собираем зазор
          this.way.car.push({ lat: this.way.current[this.way.current.length-2].lat, lng: this.way.current[this.way.current.length-2].lng });
          this.way.car.push({ lat: this.stateCar.lat, lng: this.stateCar.lng });

          // Очищаем маршруты
          this.clearPolylines();

          // Рисуем зазор
          this.polylines.gap = L.polyline(
            this.way.car,
            { color: '#676767',
              weight : 6.6 }
          );
          this.polylines.gap.addTo(map);

          // Рисуем подложку маршрута
          this.polylines.bg = L.polyline(
            this.way.current,
            { color: '#000',
              weight : 6.4 }
          );
          this.polylines.bg.addTo(map);

          // Рисуем маршрут

          this.polylines.main = L.polyline(
            this.way.current,
            { color: '#1aad03',
              weight : 6  }
          );
          this.polylines.main.addTo(map);
        }

        // Очищаем маркеры
        this.clearMarkers();
        // Рисуем новый маркер
        let marker = new L.marker(
          [this.way.car[this.way.car.length-1].lat, this.way.car[this.way.car.length-1].lng],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/map/car.svg'),
              iconSize: [45, 45],
              className : 'rotateCarIcon'
            }),
            rotationAngle : this.stateCar.course,
            rotationOrigin : 'center',
            draggable : false,
            zIndexOffset: 99,
          }
        );
        this.markers.push( marker );
        map.addLayer(marker);


        // Центрируем карту
        if( this.status.focus === true ){
          map.panTo(new L.LatLng(this.stateCar.lat, this.stateCar.lng));
        }
      },

      // Устанавливаем маркер/маршрут текущей машины
      setCar : function(){
        const L = window.L;
        const map = this.$refs.map.mapObject;

        // Центрируем карту
        if( !this.status.allCars ){
          map.setView(new L.LatLng(this.stateCar.lat, this.stateCar.lng), 15);
        }

        // Очищаем маркеры
        this.clearMarkers();

        // Рисуем новый маркер
        if( this.stateCar.coord_src === 2  ){
          let circle = new L.circle(
            [this.stateCar.lat, this.stateCar.lng],
            600,
            {color: '#12d4f0', opacity:.5});
          this.networkTower.Circles.push(circle);
          circle.addTo(map);
        }
        let marker = new L.marker(
          [this.stateCar.lat, this.stateCar.lng],
          {
            icon : L.icon({
              iconUrl: require('../assets/img/i-stop.svg'),
              iconSize: [25, 25],
            }),
            draggable : false
          }
        );

        this.markers.push( marker );
        map.addLayer(marker);
      },


      // Получаем последний маршрут машины
      getLastWay : function () {
        const L = window.L;
        const map = this.$refs.map.mapObject;
        // Очищаем маршрут
        this.clearPolylines();

        if( this.status.activeLast ){
          // Рисуем новый
          if( this.routeCar.tail.length ){
            this.way.last = this.routeCar.tail;

            // Рисуем подложку маршрута
            this.polylines.bg = L.polyline(
              this.way.last,
							{ color: '#000000',
                weight : 6.6 }
						);
            this.polylines.bg.addTo(map);

            // Рисуем маршрут
            this.polylines.main  = L.polyline(
              this.way.last,
							{ color: '#1aad03',
                weight : 6  }
						);
            this.polylines.main.addTo(map);

            // Центрируем карту
            if( this.routeCar.tail.length < 2 ){
              map.setView(new L.LatLng(this.stateCar.lat, this.stateCar.lng), 15);
						}else{
              map.fitBounds(this.polylines.bg.getBounds());
            }
          }else{
            this.status.activeLast = false;
            this.getLastWay();
          }
        }else{
          // Центрируем карту
          map.setView(new L.LatLng(this.stateCar.lat, this.stateCar.lng), 15);
        }
      },


      // Тугл всех машин на карте
      toggleAllCars : function () {
        this.status.allCars = this.status.allCars === false;
        const map = this.$refs.map.mapObject;

        if( this.status.allCars === true ){
          let markers = this.$store.state.cars.state;
          let positionMarkers = [];

          for( let item in markers ) {
            if (markers[item]) {
              positionMarkers.push([ markers[item].lat, markers[item].lng ]);
            }
          }
          map.fitBounds(positionMarkers)
        }

        this.showAllCars();
      },
      // Отрисовка всех машин на карте
      showAllCars : function () {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        // Очищаем маркеры
        for( let key in this.markerList ){
          if( this.markerList[key] ){
            map.removeLayer(this.markerList[key]);
            this.markerList[key] = '';
          }
          if( this.plateAll[key] ){
            map.removeLayer(this.plateAll[key]);
            this.plateAll[key] = '';
          }
        }

        if( this.status.allCars === false ){
          // Центрируем карту
          map.panTo(new L.LatLng(this.stateCar.lat, this.stateCar.lng));
        }else{
          let markers = this.$store.state.cars.state;

          for( let item in markers ){
            // Сами машины
            if( !this.markerList[item] && markers[item] && parseInt(item) !== parseInt(this.currentId) ){
              if( markers[item].is_in_route ) { // В пути
                this.markerList[item] = new L.marker(
                  [markers[item].lat, markers[item].lng],
                  {
                    icon : L.icon({
                      iconUrl: require('../assets/img/map/car.svg'),
                      iconSize: [45, 45],
                      className : 'rotateCarIcon'
                    }),
                    rotationAngle : markers[item].course,
                    rotationOrigin : 'center',
                  },
                );
                map.addLayer( this.markerList[item] );
              }else{ // стоянка
                this.markerList[item] = new L.marker(
                  [markers[item].lat, markers[item].lng],
                  {
                    icon : L.icon({
                      iconUrl: require('../assets/img/map/stop-other.png'),
                      iconSize: [28, 32],
                    }),
                  }
                );
                map.addLayer(this.markerList[item]);
              }
            }
            // Номера машин
            if( markers[item] ){

              this.plateAll[item] = new L.marker(
                [markers[item].lat, markers[item].lng],
                {
                  icon : new L.DivIcon({
                    className: 'plate-marker',
                    html: '<span>' +  this.plateList[item] + '</span>',
                    iconAnchor : [32, -12],
                  }),
                  draggable : false
                }
              );
              map.addLayer(this.plateAll[item]);
            }

            this.plateAll[item].on('click', () => {
              this.$store.dispatch('markerMap', item);
            });
            this.markerList[item].on('click', () => {
              this.$store.dispatch('markerMap', item);
            });
          }
        }
      },
      // Устанавливаем маркер не активной машины
      setOtherCar : function ( id, carData ) {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        if( this.markerList[id] ){
          map.removeLayer(this.markerList[id]);
          this.markerList[id] = '';
        }
        if( this.plateAll[id] ){
          map.removeLayer(this.plateAll[id]);
          this.plateAll[id] = '';
        }

        if( carData.is_in_route ) { // В пути
          this.markerList[id] = new L.marker(
            [carData.lat, carData.lng],
            {
              icon : L.icon({
                iconUrl: require('../assets/img/map/car.svg'),
                iconSize: [45, 45],
                className : 'rotateCarIcon'
              }),
              rotationAngle : carData.course,
              rotationOrigin : 'center',
              draggable : false,
              zIndexOffset: 99,
            }
          );
          map.addLayer( this.markerList[id] );
          this.markerList[id]._icon.style.transform += ' rotate(' + carData.course + 'deg)';
        }else{ // стоянка
          this.markerList[id] = new L.marker(
            [carData.lat, carData.lng],
            {
              icon : L.icon({
                iconUrl: require('../assets/img/map/stop-other.png'),
                iconSize: [28, 32],
              }),
              draggable : false
            }
          );
          map.addLayer(this.markerList[id]);
        }

        // Номера машин
        this.plateAll[id] = new L.marker(
          [carData.lat, carData.lng],
          {
            icon : new L.DivIcon({
              className: 'plate-marker',
              html: '<span>' +  this.plateList[id] + '</span>',
              iconAnchor : [32, -12],
            }),
            draggable : false
          }
        );
        map.addLayer(this.plateAll[id]);

        this.plateAll[id].on('click', () => {
          this.$store.dispatch('markerMap', id);
        });
        this.markerList[id].on('click', () => {
          this.$store.dispatch('markerMap', id);
        });

      },

      // Очистка полилиний
      clearPolylines : function () {
        const map = this.$refs.map.mapObject;

        if( this.polylines.bg !== '' ){
          map.removeLayer( this.polylines.bg );
          this.polylines.bg = '';
        }
        if( this.polylines.main !== '' ) {
          map.removeLayer( this.polylines.main );
          this.polylines.main = '';
        }
        if( this.polylines.gap !== '' ) {
          map.removeLayer( this.polylines.gap );
          this.polylines.gap = '';
        }
        if( this.polylines.day.bg.length ){
          for( let i = 0; i < this.polylines.day.bg.length; i++ ){
            map.removeLayer( this.polylines.day.bg[i] );
            map.removeLayer( this.polylines.day.main[i] );
          }
          this.polylines.day.bg = [];
          this.polylines.day.main = [];
        }
        if( this.speedWay.mapObjects.length ){
          for( let i = 0; i < this.speedWay.mapObjects.length; i++ ){
            map.removeLayer( this.speedWay.mapObjects[i] );
          }
          this.speedWay.mapObjects = [];
        }
        if( this.networkTower.Circles.length ){
          for( let i = 0; i < this.networkTower.Circles.length; i++ ){
            map.removeLayer( this.networkTower.Circles[i] )
          }
          this.networkTower.Circles = [];
        }
        /*
        if( this.speedWay.infoWindow.length ){
          if( this.speedWay.lastInfoIndex !== -1  ){
            this.speedWay.infoWindow[this.speedWay.lastInfoIndex].close();
            this.speedWay.lastInfoIndex = -1;
          }
          this.speedWay.infoWindow = [];
        }
        */
      },
      // Очистка маркеров
      clearMarkers : function () {
        const map = this.$refs.map.mapObject;

        for( let i = 0; i < this.markers.length; i++ ){
          map.removeLayer(this.markers[i]);
        }
        this.markers = [];

        if( this.status.allCars === false ){
          for( let i = 0; i < this.markersAll.length; i++ ){
            map.removeLayer(this.markers[i]);
          }
          this.markersAll = [];
        }
      },


      // Масштабирование карты
      zoomIn : function () {
        this.$refs.map.mapObject.zoomIn()
      },
      zoomOut : function () {
        this.$refs.map.mapObject.zoomOut()
      },

      // Тумблер последнего маршрута
      toggleLastPath : function () {
        // toggle Last Path
        this.status.activeLast = this.status.activeLast !== true;

        if( this.currentId !== '' && this.panelCar !== 2 ){
          this.getLastWay();
        }
      },
      toggleFocus : function () {
        const L = window.L;
        const map = this.$refs.map.mapObject;

        if( this.status.focus === true ){
          this.status.focus = false;
        }else{
          if( this.currentId !== '' ){
          	map.panTo(new L.LatLng(this.stateCar.lat, this.stateCar.lng));
          }
          this.status.focus = true;
        }
      },

      changeMapType : function ( type ) {
        this.$store.dispatch('changeMapType', type );
      },
      toogleMapChoise : function () {
        this.$store.dispatch('changeMapChoise');
      }
		},
    watch : {
      // Поменялась активная машина
      currentId : function() {
        if (this.currentId !== '' && this.stateCar && this.routeCar ) {
          this.changeCar();
        }
      },

      // Поменялся активный пункт меню авто
      panelCar : function () {
        this.clearMarkers();
        this.clearPolylines();
        // Строим под нужную вкладку
        if( this.panelCar === 1 ){       // Управление
          this.setManagment();
        }
      },

      // Поменялось состояние машины
      lastState : function ( newVal ) {
        if( this.panelCar === 1 ){
          if( this.currentId !== '' ){
            if( newVal.car_id === this.currentId ){
              this.changeState();
            }else{
              if( this.status.allCars ){
                this.setOtherCar( newVal.car_id, newVal.data );
              }
            }
          }else{
            if( this.status.allCars ){
              this.setOtherCar( newVal.car_id, newVal.data );
            }
          }
        }
      },
      lastRoute : function ( newVal ) {
        if( newVal.car_id === this.currentId ){
          if( this.panelCar === 1 && this.currentId !== '' ){
            this.changeRoute()
          }
        }
      },
		},
		components : {
      LMap,
			LTileLayer,
      'v-rotated-marker': Vue2LeafletRotatedMarker
		}
  }
</script>